// @flow

import * as React from 'react';
import { OutlinedInput } from '@material-ui/core';
import { useRifm } from 'rifm';
import { parse, format, isValid } from 'date-fns';

type Props = {|
  value: string,
  onChange: string => void,
  onBlur?: () => void,
|};

const DATE_FORMAT = 'dd/MM/yyyy';

const isEmpty = value =>
  value == null || (typeof value === 'string' && value.trim().length === 0);

export const parseDate = (date: string): null | Date => {
  const parsed = parse(date, DATE_FORMAT, Date.now());
  if (!isValid(parsed)) {
    return null;
  }
  return parsed;
};

export const formatDate = (date: Date): string => {
  return format(date, DATE_FORMAT);
};

const refuse = /[^\d]+/gi;

const parseDateString = string => string.replace(refuse, '');

const formatTimeString = (string: string) => {
  const parsed = parseDateString(string);
  if (isEmpty(parsed)) {
    return '';
  }
  const days = parsed.slice(0, 2).padEnd(2, '_');
  const months = parsed.slice(2, 4).padEnd(2, '_');
  const years = parsed.slice(4, 8).padEnd(4, '_');
  return `${days}/${months}/${years}`;
};

export const DateInput = (props: Props): React.Node => {
  const rifm = useRifm({
    format: formatTimeString,
    value: props.value,
    onChange: newValue => props.onChange(newValue),
  });
  return (
    <OutlinedInput
      value={rifm.value}
      onChange={rifm.onChange}
      placeholder={DATE_FORMAT}
      onBlur={props.onBlur}
      labelWidth={0}
    />
  );
};
